import Details from "./forms/Details";
import Editor from "./forms/Editor";
import List from "./forms/List";
import DefaultLoader from "components/common/DefaultLoader";
import { useEffect } from "react";
import { connect } from "react-redux";
import { Route, Routes } from "react-router-dom";
import * as exposureActions from "store/actions/input/exposure/exposureActions";

const FormApp = ({ isSubmissionLoading, loadAllIndustryClasses }) => {
  useEffect(() => loadAllIndustryClasses(), [loadAllIndustryClasses]);

  return (
    <>
      {isSubmissionLoading ? (
        <DefaultLoader
          size={100}
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      ) : (
        <Routes>
          <Route path={"/"} element={<List />} replace />
          <Route path={"/new"} element={<Editor />} />
          <Route path={":formId/edit"} element={<Editor />} />
          <Route path={":formId"} element={<Details />} />
        </Routes>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    isSubmissionLoading: state.persistence?.isLoading ?? false,
  };
};

const mapDispatchToProps = {
  loadAllIndustryClasses: exposureActions.loadAllIndustryClasses,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormApp);
